import { Perimeter } from 'vue-kindergarten';
import _find from 'lodash/find';

/* eslint-enable */

export default class BasePerimeter extends Perimeter {
  isAdmin() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'admin' });
  }

  isDriver() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'fahrer' });
  }

  isKitchenTeam() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'küchenteam' });
  }

  isEmployee() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'küchenteam' }) || !!_find(this.child.roles, { name: 'fahrer' });
  }

  isManager() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'manager' });
  }

  isCreator(entity) {
    if (entity) {
      return this.child.id === entity.user_id;
    }
    return true;
  }

  isBaseRole() {
    return !!_find(this.child.roles, { name: 'base' });
  }
}



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/BasePerimiter.js